import * as T from './redux.actionTypes';

// List
export const fetchClients = (params) => ({ type: T.FETCH_CLIENTS, payload: params });
export const fetchClientsSuccess = (payload) => ({ type: T.FETCH_CLIENTS_SUCCESS, payload });
export const fetchClientsFailure = (error) => ({ type: T.FETCH_CLIENTS_FAILURE, payload: error });

// Detail
export const fetchClientDetail = (id) => ({ type: T.FETCH_CLIENT_DETAIL, payload: { id } });
export const fetchClientDetailSuccess = (payload) => ({ type: T.FETCH_CLIENT_DETAIL_SUCCESS, payload });
export const fetchClientDetailFailure = (error) => ({ type: T.FETCH_CLIENT_DETAIL_FAILURE, payload: error });
export const clearClientDetail = () => ({ type: T.CLEAR_CLIENT_DETAIL });

// CRUD
export const createClient = (payload) => ({ type: T.CREATE_CLIENT, payload });
export const createClientSuccess = (payload) => ({ type: T.CREATE_CLIENT_SUCCESS, payload });
export const createClientFailure = (error) => ({ type: T.CREATE_CLIENT_FAILURE, payload: error });

export const updateClient = (id, data) => ({ type: T.UPDATE_CLIENT, payload: { id, data } });
export const updateClientSuccess = (payload) => ({ type: T.UPDATE_CLIENT_SUCCESS, payload });
export const updateClientFailure = (error) => ({ type: T.UPDATE_CLIENT_FAILURE, payload: error });

export const deleteClient = (id) => ({ type: T.DELETE_CLIENT, payload: { id } });
export const deleteClientSuccess = (id) => ({ type: T.DELETE_CLIENT_SUCCESS, payload: { id } });
export const deleteClientFailure = (error) => ({ type: T.DELETE_CLIENT_FAILURE, payload: error });

// Websites
export const addClientWebsite = (clientId, data) => ({ type: T.ADD_CLIENT_WEBSITE, payload: { clientId, data } });
export const addClientWebsiteSuccess = (website) => ({ type: T.ADD_CLIENT_WEBSITE_SUCCESS, payload: website });
export const updateClientWebsite = (clientId, websiteId, data) => ({ type: T.UPDATE_CLIENT_WEBSITE, payload: { clientId, websiteId, data } });
export const updateClientWebsiteSuccess = (website) => ({ type: T.UPDATE_CLIENT_WEBSITE_SUCCESS, payload: website });
export const deleteClientWebsite = (clientId, websiteId) => ({ type: T.DELETE_CLIENT_WEBSITE, payload: { clientId, websiteId } });
export const deleteClientWebsiteSuccess = (websiteId) => ({ type: T.DELETE_CLIENT_WEBSITE_SUCCESS, payload: { websiteId } });

// Periods
export const addClientPeriod = (clientId, data) => ({ type: T.ADD_CLIENT_PERIOD, payload: { clientId, data } });
export const addClientPeriodSuccess = (period) => ({ type: T.ADD_CLIENT_PERIOD_SUCCESS, payload: period });
export const updateClientPeriod = (clientId, periodId, data) => ({ type: T.UPDATE_CLIENT_PERIOD, payload: { clientId, periodId, data } });
export const updateClientPeriodSuccess = (period) => ({ type: T.UPDATE_CLIENT_PERIOD_SUCCESS, payload: period });
export const deleteClientPeriod = (clientId, periodId) => ({ type: T.DELETE_CLIENT_PERIOD, payload: { clientId, periodId } });
export const deleteClientPeriodSuccess = (periodId) => ({ type: T.DELETE_CLIENT_PERIOD_SUCCESS, payload: { periodId } });

// Git Repos
export const addClientGitRepo = (clientId, data) => ({ type: T.ADD_CLIENT_GIT_REPO, payload: { clientId, data } });
export const addClientGitRepoSuccess = (repo) => ({ type: T.ADD_CLIENT_GIT_REPO_SUCCESS, payload: repo });
export const updateClientGitRepo = (clientId, repoId, data) => ({ type: T.UPDATE_CLIENT_GIT_REPO, payload: { clientId, repoId, data } });
export const updateClientGitRepoSuccess = (repo) => ({ type: T.UPDATE_CLIENT_GIT_REPO_SUCCESS, payload: repo });
export const deleteClientGitRepo = (clientId, repoId) => ({ type: T.DELETE_CLIENT_GIT_REPO, payload: { clientId, repoId } });
export const deleteClientGitRepoSuccess = (repoId) => ({ type: T.DELETE_CLIENT_GIT_REPO_SUCCESS, payload: { repoId } });

// Stack
export const addClientStack = (clientId, data) => ({ type: T.ADD_CLIENT_STACK, payload: { clientId, data } });
export const addClientStackSuccess = (stack) => ({ type: T.ADD_CLIENT_STACK_SUCCESS, payload: stack });
export const updateClientStack = (clientId, stackId, data) => ({ type: T.UPDATE_CLIENT_STACK, payload: { clientId, stackId, data } });
export const updateClientStackSuccess = (stack) => ({ type: T.UPDATE_CLIENT_STACK_SUCCESS, payload: stack });
export const deleteClientStack = (clientId, stackId) => ({ type: T.DELETE_CLIENT_STACK, payload: { clientId, stackId } });
export const deleteClientStackSuccess = (stackId) => ({ type: T.DELETE_CLIENT_STACK_SUCCESS, payload: { stackId } });

// Employees
export const assignEmployee = (clientId, data) => ({ type: T.ASSIGN_EMPLOYEE, payload: { clientId, data } });
export const assignEmployeeSuccess = (employee) => ({ type: T.ASSIGN_EMPLOYEE_SUCCESS, payload: employee });
export const updateEmployeeAssignment = (clientId, email, data) => ({ type: T.UPDATE_EMPLOYEE_ASSIGNMENT, payload: { clientId, email, data } });
export const updateEmployeeAssignmentSuccess = (employee) => ({ type: T.UPDATE_EMPLOYEE_ASSIGNMENT_SUCCESS, payload: employee });
export const unassignEmployee = (clientId, email) => ({ type: T.UNASSIGN_EMPLOYEE, payload: { clientId, email } });
export const unassignEmployeeSuccess = (email) => ({ type: T.UNASSIGN_EMPLOYEE_SUCCESS, payload: { email } });

// Teams
export const assignTeam = (clientId, teamId) => ({ type: T.ASSIGN_TEAM, payload: { clientId, teamId } });
export const assignTeamSuccess = (clientTeam) => ({ type: T.ASSIGN_TEAM_SUCCESS, payload: clientTeam });
export const unassignTeam = (clientId, teamId) => ({ type: T.UNASSIGN_TEAM, payload: { clientId, teamId } });
export const unassignTeamSuccess = (teamId) => ({ type: T.UNASSIGN_TEAM_SUCCESS, payload: { teamId } });
export const fetchTeamOptions = () => ({ type: T.FETCH_TEAM_OPTIONS });
export const fetchTeamOptionsSuccess = (payload) => ({ type: T.FETCH_TEAM_OPTIONS_SUCCESS, payload });
export const fetchTeamOptionsFailure = (error) => ({ type: T.FETCH_TEAM_OPTIONS_FAILURE, payload: error });

// Created entity navigation flag
export const clearLastCreatedClient = () => ({ type: T.CLEAR_LAST_CREATED_CLIENT });

// UI
export const openClientDialog = (client = null) => ({ type: T.OPEN_CLIENT_DIALOG, payload: client });
export const closeClientDialog = () => ({ type: T.CLOSE_CLIENT_DIALOG });
export const openDeleteDialog = (client) => ({ type: T.OPEN_DELETE_DIALOG, payload: client });
export const closeDeleteDialog = () => ({ type: T.CLOSE_DELETE_DIALOG });
export const openDetailDialog = (client) => ({ type: T.OPEN_DETAIL_DIALOG, payload: client });
export const closeDetailDialog = () => ({ type: T.CLOSE_DETAIL_DIALOG });

export const setFilters = (filters) => ({ type: T.SET_FILTERS, payload: filters });
export const setPagination = (pagination) => ({ type: T.SET_PAGINATION, payload: pagination });
export const setSort = (sort) => ({ type: T.SET_SORT, payload: sort });

// Employee options (for assign-employee picker)
export const fetchEmployeeOptions = () => ({ type: T.FETCH_EMPLOYEE_OPTIONS });
export const fetchEmployeeOptionsSuccess = (payload) => ({ type: T.FETCH_EMPLOYEE_OPTIONS_SUCCESS, payload });
export const fetchEmployeeOptionsFailure = (error) => ({ type: T.FETCH_EMPLOYEE_OPTIONS_FAILURE, payload: error });
